import config from '$config';

const buildFor = process.env.BUILD_FOR || 'maia';

// The Renault image is built with BUILD_FOR=maia-renault. Prefer that over the
// runtime segment group so this deployment never renders Motrio chrome.
export const isRenault = config.segmentGroup === 'RENAULT' || buildFor === 'maia-renault';

export const isMotrio = !isRenault && config.segmentGroup === 'MOTRIO';

/** Shell / chrome colours shared by AppShell and sidebar controls. */
export const colors = {
  white: '#ffffff',
  black: '#000000',
  mutedText: 'rgba(0, 0, 0, 0.65)',
  renaultYellow: '#EEDF00',
  motrioRed: '#E00008',
  motrioPink: '#ef8bc0',
  fixterOrange: '#ce5628',
};

const isPreProd = ['development', 'staging'].includes(config.env);

/**
 * Sidebar chrome for the current brand. `background` is null when Ant Design's
 * default dark sider should be left alone (Fixter production).
 */
export function getSiderChrome() {
  if (isRenault) {
    return {
      background: colors.renaultYellow,
      foreground: colors.black,
      selectedBackground: colors.black,
      selectedForeground: colors.white,
    };
  }

  if (isMotrio) {
    return {
      background: isPreProd ? colors.motrioPink : colors.motrioRed,
      foreground: colors.white,
      selectedBackground: colors.white,
      selectedForeground: colors.black,
    };
  }

  if (isPreProd) {
    return {
      background: colors.fixterOrange,
      foreground: colors.white,
      selectedBackground: colors.white,
      selectedForeground: colors.black,
    };
  }

  return {
    background: null,
    foreground: colors.white,
    selectedBackground: colors.white,
    selectedForeground: colors.black,
  };
}
